var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"st-footer"},[_c('div',{staticClass:"st-copy"},[_c('p',{staticClass:"st-copyInfo"},[_vm._v("Copyright © 2019 SHAREit")])])])}]

export { render, staticRenderFns }